import React, { Component } from 'react';
import { loginActions } from '../../action/loginAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Header from '../../Header/Header';
import { alertActions } from '../../action/AlertAction';
import { gameActions } from '../../action/GameAction';
import { Helmet } from 'react-helmet';
import Rating from '@mui/material/Rating';
class Feedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Feedback: '',
            starValue: 0,
            MaximummsgCount: 200,
            RatingArr: [1, 2, 3, 4, 5]
        }
    }

    handleTextChange(e) {
        try {
            let value = e.target.value
            this.setState({ [e.target.name]: value });
        } catch (ex) { }
    }


    SumbitButton = () => {
        if (this.props.user.mobileNo != '0') {
            if (this.state.Feedback && this.state.Feedback.trim().length != 0) {
                if (this.state.starValue > 0) {
                    this.state.Feedback = this.state.Feedback.replace(/'/g, "''");
                    let data = { "reviewpoints": parseInt(this.state.starValue), "message": this.state.Feedback };
                    this.props.SendUserratings(data, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
                    this.setState({
                        Feedback: '',
                        starValue: 0
                    })
                }
                else {
                    this.showMsg('lblwithoutrating');
                }
            }
            else {
                this.showMsg('lblsometxt');
            }
        }
        else {
            this.showMsg('lblplsloginTry');
        }

    }

    showMsg = (msg) => { this.props.alertError(this.props.t(msg)); }



    GetStarts = (e) => {
        this.setState({ starValue: e.target.value })
    }
    GetStartsNew = (val) => {
        this.setState({ starValue: val })
    }

    render() {
        const { t } = this.props;
        let messageText = this.state.Feedback.trim().length;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : Feedback</title>
                    <meta name="description" content="Gulf Ticket Feedback" />
                </Helmet>
                }
                {/* <Header /> */}
                
                    <h2 class="headding1 padding-top-0">{t('lblFeedback')}</h2>
                    <div className="feedbackCont">
                        <div className="">
                            <h2 className="headding2 padding-top-0">{t('lblvalComments')} </h2>
                            {/* <form className="contactForm" name="contactForm" id="contactForm" method="post" novalidate="novalidate"> */}
                            <div className="formFeedback">
                                <textarea value={this.state.Feedback} name="Feedback" onChange={(e) => { this.handleTextChange(e) }} maxLength={200} id="Feedback" cols="30" rows="10" className="form-control required" aria-required="true"></textarea>
                                <small class="texterMsg">({messageText <= 0 ? t('lblmax') : t('lbltexteft')} {messageText <= 0 ? this.state.MaximummsgCount : this.state.MaximummsgCount - messageText})</small>
                            </div>
                            <div className="feedbackratings" >
                                <h2>{t('lblstarttxt')}</h2>
                                {/*  <input onClick={(e) => { this.GetStarts(e) }} type="radio" id="5-stars" name="rating" value="5" checked={this.state.starValue == "5"} />
                                <label for="5-stars" className="star">&#9733;</label>
                                <input onClick={(e) => { this.GetStarts(e) }} type="radio" id="4-stars" name="rating" value="4" checked={this.state.starValue == "4"} />
                                <label for="4-stars" className="star">&#9733;</label>
                                <input onClick={(e) => { this.GetStarts(e) }} type="radio" id="3-stars" name="rating" value="3" checked={this.state.starValue == "3"} />
                                <label for="3-stars" className="star">&#9733;</label>
                                <input onClick={(e) => { this.GetStarts(e) }} type="radio" id="2-stars" name="rating" value="2" checked={this.state.starValue == "2"} />
                                <label for="2-stars" className="star">&#9733;</label>
                                <input onClick={(e) => { this.GetStarts(e) }} type="radio" id="1-star" name="rating" value="1" checked={this.state.starValue == "1"} />
                                <label for="1-star" className="star">&#9733;</label> */}
                                {this.state.RatingArr.map((x) =>
                                    <span class="">
                                        <svg onClick={() => { this.GetStartsNew(x) }} class={this.state.starValue >= x ? "star-outline active" : "star-outline"} viewBox="0 0 24 24" width="30" height="30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path d="M12 2.5l2.85 5.77 6.36.93-4.6 4.49 1.09 6.34L12 17.77 6.3 20.03l1.09-6.34L2.79 9.2l6.36-.93L12 2.5z"
                                                fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round" />
                                        </svg></span>
                                )}
                            </div>
                            <div className="formFeedback" >
                                <div className="col-md-4 field">
                                    <div id="Alert1"></div>
                                    <div id="Loader1" style={{ display: "none" }}>
                                        <img src="img/loder.gif" width="50" height="50" alt='loder icon' />
                                    </div>
                                    <button onClick={() => { this.SumbitButton() }} className="bg-game9 sendMsgBtn" name="send" id="send" type="button">{t('lblSubmit')}</button>
                                </div>
                            </div>
                            {/* </form> */}
                        </div>
                    </div>
            </>
        )
    }
}
function mapStateToProps(state) {
    const { user } = state.loginReducer;
    return { user };
}
const mapActionToProps = {
    alertError: alertActions.error,
    SendUserratings: gameActions.SendUserratings
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Feedback))